import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
  providedIn: 'root'
})
export class LanguageService {

  supportedLangs = ['fr-FR', 'en-EN', 'de-DE']; 
  
  constructor(
    private translate: TranslateService,
  ) {
    const browserLanguage = navigator.language;
    if (this.supportedLangs.includes(browserLanguage)) {
      this.setLanguage(browserLanguage)
    } 
  }

  getLanguage(): string {
    return this.translate.currentLang;
  }

  setLanguage(lang: string) {
    this.translate.use(lang);
  }
}
